<template>
    <div class="material-box">
        <div class="content-li" v-for="(value, index) in materialList" :key="value.id" :style="{'position': 'absolute', 'left': 0, top: `${(index - materialIndex) * 100}%`}">
            <materialCompoent :materialObj="value"/>
        </div>

        <div class="top-page-part" v-show="showTopPagePart" @click="previousClick">
            <font-awesome-icon icon="fa-solid fa-angles-up" />
        </div>

        <div class="bottom-page-part" v-show="showBottomPagePart" @click="nextClick">
            <font-awesome-icon icon="fa-solid fa-angles-down" />
        </div>

        <span>{{computeCompany}}</span>
    </div>
</template>

<script setup>
    import {getCurrentInstance, ref, computed} from 'vue'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import {faAnglesUp, faAnglesDown} from '@fortawesome/free-solid-svg-icons'
    import {library} from "@fortawesome/fontawesome-svg-core";
    import materialCompoent from '@/components/materialCompoent.vue'

    library.add(faAnglesUp, faAnglesDown)

    const emits = defineEmits(['post-complete'])
    const props = defineProps(['companycode'])

    let { proxy } = getCurrentInstance();
    let Axios = proxy.$Axios;

    const materialIndex = ref(0)
    const materialList = ref([])
    const showTopPagePart = computed(() => {
        if (materialIndex.value > 0){
            return true
        }

        return false
    })

    const showBottomPagePart = computed(() => {
        if (materialIndex.value < materialList.value.length - 1){
            return true
        }

        return false
    })

    const computeCompany = computed(() => {
        if (props.companycode != null){
            getMaterialInfo()
        }

        return ""
    })

    function getMaterialInfo(){
        if (null != props.companycode){
            const data = {
                companycode: props.companycode,
                pageNum: 1,
                pageSize: 50,
                postype: 0,
                verify: -1
            }

            Axios.post(proxy.$ShopopeeUrl + '/material/queryMaterialByPage', data).then((response) => {
                if (response.code === 200){
                    // let list = response.detail.list
                    // list = list.concat(list)
                    // list = list.concat(list)

                    materialList.value = response.detail.list
                    // materialList.value = list
                }else{
                    materialList.value = []
                }

                materialIndex.value = 0

                emits("post-complete")
            })
        }

    }

    function previousClick() {
        if (materialIndex.value > 0){
            materialIndex.value -= 1
        }
    }

    function nextClick() {
        if (materialIndex.value < materialList.value.length - 1){
            materialIndex.value += 1
        }
    }
</script>

<style scoped>
    ul {
        list-style: none;
        margin: 0;
        padding-left: 0;
    }

    .content-li {
        width: 100%;
        height: 100%;
        transition: all 1.5s ease;
    }

    .material-box {
        width: 100%;
        height: 100%;
        overflow-y: hidden;
        overflow-x: hidden;
        position: relative;
    }

    .material-box .top-page-part {
        position: absolute;
        width: 100%;
        height: 5%;
        left: 0;
        top: 0;
        background: linear-gradient(#333333a3, #ffffff00 100%);
        text-align: center;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .material-box .bottom-page-part {
        position: absolute;
        width: 100%;
        height: 5%;
        left: 0;
        bottom: 0;
        background: linear-gradient(#ffffff00, #333333a3 100%);
        text-align: center;
        line-height: 100%;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>